import { BaseContext } from '../../../utils/basecontext';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from '../uicomponent';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { UIComponentView } from '../uicomponentview';
import { ToggleButtonCSSStyle } from '../togglebutton/togglebuttoncss';
import { ToggleButtonGroupView } from './togglebuttongroupview';
import { ToggleButtonGroupCSSStyleImpl } from './togglebuttongroupcss';


export interface ToggleButtonGroupProps extends UIComponentProps
{
    listOfTitles: string[];
    style: ToggleButtonCSSStyle;
    initialSelection: string;
    onTabSelected(title: string): void;
}
export interface ToggleButtonGroupState extends UIComponentState
{
    listOfTitles: string[];
    selectedTab:string;
}

export interface ToggleButtonGroupHandler extends UIComponentHandler
{
    onButtonSelected(title: string): void;
}

export class ToggleButtonGroupComponent extends UIComponentImpl<ToggleButtonGroupProps, ToggleButtonGroupState, UIDataModel> implements ToggleButtonGroupHandler
{
    constructor(props: ToggleButtonGroupProps)
    {
        super(props);

        this.state = {listOfTitles: props.listOfTitles, selectedTab: props.initialSelection};
    }
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ToggleButtonGroupView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ToggleButtonGroupCSSStyleImpl(applicationContext);
    }

    onButtonSelected(title: string): void 
    {
        this.setState({selectedTab: title});
        
       this.props.onTabSelected(title);
    }
    UNSAFE_componentWillReceiveProps(nextProps: ToggleButtonGroupProps)
    {
        console.log("-----UNSAFE_componentWillReceiveProps: " + JSON.stringify(nextProps.listOfTitles));
        this.setState({selectedTab: nextProps.initialSelection, listOfTitles: nextProps.listOfTitles});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/togglebuttongroup/togglebuttongroupcomponent.tsx